import { matchPath } from 'react-router-dom';

import { TypeScreenBorder } from './TypeScreenBorder';

type OrgRef = {
  rowId: string;
  organizationType?: string | null;
};

type OrgsConnection = { nodes: readonly OrgRef[] };

type Props = {
  location?: { pathname?: string } | null;
  user?: { organizations?: OrgsConnection | null } | null;
  superUserOrgs?: OrgsConnection | null;
};

/**
 * Resolves the organization from the URL (`/organization/:orgId`) — the same
 * way the header badge does — and renders a screen frame in that org type's
 * color. Scoped to organization pages: no `:orgId` in the URL means no frame.
 *
 * Pure/props-driven on purpose: it is mounted inside `SignedInViewer`, which
 * already has `user`, `superUserOrgs` and `location`. Pulling those in via the
 * `withUser`/`withRouter` HOCs would create an import cycle with the wrapper
 * that defines `withUser`.
 */
export const RouteTypeBorder = ({ location, user, superUserOrgs }: Props) => {
  const orgs: readonly OrgRef[] =
    superUserOrgs?.nodes ?? user?.organizations?.nodes ?? [];

  const orgId = matchPath<{ orgId?: string }>(location?.pathname ?? '', {
    path: '/organization/:orgId'
  })?.params?.orgId;

  if (!orgId) {
    return null;
  }

  const current = orgs.find(org => String(org.rowId) === String(orgId));
  return <TypeScreenBorder type={current?.organizationType} />;
};
